import Link from 'next/link';
import { FC } from 'react';
import { IoLinkOutline } from 'react-icons/io5';

import { ActionIcon, Button, Group, Tooltip } from '@mantine/core';

import { CompanyProfile, SavedItemType } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { SaveButton } from 'components/buttons/SaveButton';
import { ShareButton } from 'components/company-profile/components/ShareButton';
import { InternalTrackingService } from 'services/InternalTrackingService';

import cx from './Header.module.scss';

const HeaderButtons: FC<{ company: CompanyProfile }> = ({ company }) => {
    return (
        <Group gap={6} wrap="nowrap">
            <SaveButton
                id={company.id}
                name={company.name}
                type={SavedItemType.PROFILE}
                company={company}
                iconOnly
                actionIconProps={{ size: 32, className: cx.circle }}
            />
            <ShareButton company={company} />
            {company.website && (
                <Tooltip label="Visit website">
                    <ActionIcon
                        component="a"
                        href={company.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Visit website"
                        variant="white"
                        size={32}
                        radius={99}
                        className={cx.circle}
                        {...InternalTrackingService.link('company.social.website', 'Visit website')}
                    >
                        <IoLinkOutline size={16} />
                    </ActionIcon>
                </Tooltip>
            )}
        </Group>
    );
};

const HeaderButtonsView: FC<{ company: CompanyProfile }> = ({ company }) => {
    return (
        <Group gap="xs">
            <SaveButton
                id={company.id}
                name={company.name}
                type={SavedItemType.PROFILE}
                company={company}
                buttonProps={{
                    variant: 'outline',
                    color: 'white',
                    size: 'md',
                }}
            />

            <Button size="md" variant="white" component={Link} href={CompanyHelpers.urls.view(company.slug)}>
                Visit Profile
            </Button>
        </Group>
    );
};

export { HeaderButtons, HeaderButtonsView };
